import * as React from 'react';
import { Gauge, gaugeClasses } from '@mui/x-charts/Gauge';
// import Icons from '../../components/icons';
import { ThemeMode } from '../../context/ThemeMode';

const ArcGauge = ({ value, otherValue, startAngle, endAngle }) => {
    const settings = { value, animate: true };
    const { isDarkMode } = ThemeMode();

    return (
        <div className="arc-item common-pe-none">
            <div className="arc-gauge-bx">
                <Gauge
                startAngle={startAngle ?? -112} endAngle={endAngle ?? 112}
                    {...settings}
                    cornerRadius="25%"
                    innerRadius="75%"
                    sx={{
                        [`& .${gaugeClasses.valueText}`]: {
                            visibility: 'hidden',
                        },
                        [`& .${gaugeClasses.valueArc}`]: {
                            fill: "white",
                        },
                        [`& .${gaugeClasses.referenceArc}`]: {
                            fill: `${isDarkMode ? "#FFFFFF66" : "#0000000f"  }`,
                        },
                    }}
                />


                <div className="agb-center">
                    <div className="arc-value">{value}%</div>
                    {otherValue && <div className="arc-other-value">{otherValue}</div>}
                </div>
            </div>
        </div>
    );
};

export default ArcGauge;
